<ui-form [config]="controlsConfig" [(formValues)]="sampleControls"></ui-form>

<div class="sample-intro">
  This sample is designed to evaluate shadow consistency in nested panels.
</div>
<div class="sample-intro">
  Toggle all panels between collapse-enabled and non-toggleable modes to compare how each level renders. The EZ-Panel is based on the PrimeNG panel which renders a different DOM depending on if the panel is toggleable or not. This sample is used to test the styling in both tobbleable and non-toggleable modes to ensure consistency.
</div>

<ui-panel panelTitle="Outer Panel (Level 1)" [isToggleable]="!!sampleControls().allPanelsToggleable">
  <ui-panel panelTitle="Middle Panel (Level 2)" [isToggleable]="!!sampleControls().allPanelsToggleable">
    <ui-panel [panelHeaderConfig]="innerPanelHeaderConfig()" [isToggleable]="!!sampleControls().allPanelsToggleable">
      <ui-form [config]="innerFormConfig" [(formValues)]="sampleFormValues"></ui-form>
    </ui-panel>
  </ui-panel>
</ui-panel>
